
module.exports = function ($q, $compile, googleMapsApi, shopLocatorService, shopPageStateService, $timeout, $state, breakpointsService, geolocation, storePickerService) {
    return {
        restrict: 'E',
        scope: {
            storesList: '=?',
            searching: '=?',
            store: '=?'
        },
        template: require('./shop-locator-find-template.html'),
        link(scope) {

            scope.breakpointsService = breakpointsService;
            scope.shopLocatorService = shopLocatorService;
            scope.searching = true;
            scope.isNavMapSelected = false;
            scope.storePicker = storePickerService;


            scope.toggleView = (tab) => {
                scope.isNavMapSelected = tab === 'Map';
            };

            if (geolocation && geolocation.getCurrentPosition !== undefined) {
                geolocation.getCurrentPosition(function (position) {
                    shopLocatorService.listSupermarkets({
                        Max: 15,
                        Latitude: position.coords.latitude,
                        Longitude: position.coords.longitude
                    }).then(function (locations) {
                           scope.storesList = locations.Stores;
                           scope.searching = false;
                       });
                }, function () {
                    scope.searching = false;
                });
            } else {
                scope.searching = false;
            }
        }
    };
};



/** WEBPACK FOOTER **
 ** ./wowapp/src/shop/components/shoplocator/shop-locator-find-directive.js
 **/